import { render, staticRenderFns } from "./DetailsFlow.vue?vue&type=template&id=1f5721a2"
import script from "./DetailsFlow.vue?vue&type=script&lang=js"
export * from "./DetailsFlow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports